<template>
    <navBack></navBack>
    <t-tabs :value="activeTab" @change="onTabsChange" class="custom-tabs">
        <t-tab-panel label="可用优惠券" :value="1">
            <div class="body">
                <coupon-bar v-for="(item, index) in dataList" :key="item._id" :coupon="item.couponInfo"
                    :data-index="index" />
            </div>
        </t-tab-panel>

        <t-tab-panel label="历史记录" :value="0">
            <div class="body">
                <coupon-bar v-for="(item, index) in dataList" :key="item._id" :coupon="item.couponInfo"
                    :data-index="index">
                    <template #default>
                        <text v-if="item.status == -1">已过期</text>
                        <text v-if="item.status == 0">已使用</text>
                    </template>
                </coupon-bar>
            </div>
        </t-tab-panel>
    </t-tabs>
</template>

<script setup>
import { ref,  onMounted,getCurrentInstance } from 'vue'
import navBack  from '@/components/nav-back.vue'
import couponBar from '@/components/coupon-item-user.vue'
const { proxy } = getCurrentInstance();
import { useRoute } from 'vue-router'
import dayjs from 'dayjs';
const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
 
const route = useRoute()
// 活动标签页
const activeTab = ref(1)
const customer_Id = ref('')
// 优惠券列表数据
const dataList = ref([])

// 可用优惠券（status > 0）
 

const loadData = async function () {
   

 
    let today = dayjs().format('YYYY-MM-DD');
    const db = app.database();
    const _ = db.command;
    let status = activeTab.value == 1 ? 1 : _.lte(0);
    let customerId = customer_Id.value;
    db.collection('my_customer_coupon')
        .where({
        customerId,
        status,
        endTime: _.gt(today)
    })
        .orderBy('endTime', 'desc')
       
        .get()
        .then(res => { 
            dataList.value = res.data;
        });
 


}
// 标签页切换事件
const onTabsChange = (value) => {
    activeTab.value = value;
    loadData();
}
onMounted(() => {
    customer_Id.value = route.query.id;
    loadData();
})
</script>

<style scoped>
/* 如果需要自定义样式，可以在这里添加 */
</style>